function SensorConfigurationPage() {
    /**
     *
     */
    SensorConfigurationPage.prototype.initialize = function (console, device, index) {
        this.id = "sensorConfiguration";
        this.console = console;
        this.device = device;
        this.sensorIndex = index;

        if (index >= 0) {
            this.sensor = device.sensors[index]; // TODO Clone
        }

        return this;
    };

    /**
     *
     */
    SensorConfigurationPage.prototype.show = function () {
        var deferred = $.Deferred();

        this.console.deviceConfigurationScope = 2;

        deferred.resolve();

        return deferred.promise();
    };

    /**
     *
     */
    SensorConfigurationPage.prototype.sensorTypeChanged = function () {
        this.sensor = Sensor.create(this.device, this.device.getSensorType(this.plugin));
    };

    /**
     *
     */
    SensorConfigurationPage.prototype.createSensor = function () {
        this.device.sensors.push(this.sensor);
        this.console.popPage();
    };

    /**
     *
     */
    SensorConfigurationPage.prototype.updateActor = function () {
        this.device.sensors[this.sensorIndex] = this.sensor;

        this.console.popPage();
    };

    /**
     *
     */
    SensorConfigurationPage.prototype.leave = function () {
    };
}
